/**
 * Used to count minimalQuota of ticket item, or qty of available tickets
 *
 * @param quantity also called "Allocated"
 * @param cancelled count of Cancelled tickets
 * @param activated count of activated tickets
 * @param bought count of bought tickets
 */
export default function(
  quantity: number,
  // cancelled: number,
  activated: number,
  bought: number
): number {
  return quantity - (activated + bought);
}



// WEBPACK FOOTER //
// ./src/packages/lib/methods/ticketInventory/CountAvailable.ts